// extracted by mini-css-extract-plugin
module.exports = {"head":"cinemaoption_head__3XWoy","active":"cinemaoption_active__1fKgr"};